import React from "react";

function Color_Psychology() {
  return (
    <div>
      <h1>Color_Psychology Component</h1>
      <p>This is the Color Psychology tutorial page content.</p>
    </div>
  );
}

export default Color_Psychology;
